import { View } from 'react-native';

import { Box, HStack, VStack, theme } from '@squire/ui';

import { Card } from '@/components/_shared/Card';
import { Skeleton } from '@/components/_shared/Skeleton';

import { styles } from './styles';
import type { ServiceGridSkeletonProps } from './types';

const ServiceGridSkeleton = ({
  columns,
  testID = 'service-grid-loading',
}: ServiceGridSkeletonProps) => {
  return (
    <View style={styles.container} testID={testID}>
      <HStack style={styles.servicesGrid}>
        {Array.from({ length: 7 }).map((_, index) => (
          <Box key={index} style={styles.gridItem(columns)}>
            <Card
              space={theme.spacing[3]}
              padding={theme.spacing[4]}
              style={styles.card}
              testID={`service-skeleton-${index}`}
            >
              <VStack space={theme.spacing[2]} padding={theme.spacing[2]}>
                <Skeleton variant="text" width="55%" height={17} />
                <Skeleton variant="text" width="38%" height={10} />
              </VStack>
              <Skeleton style={styles.priceSkeleton} />
            </Card>
          </Box>
        ))}
      </HStack>
    </View>
  );
};

ServiceGridSkeleton.displayName = 'ServiceGridSkeleton';
export { ServiceGridSkeleton };
